import React from "react";

import Timeline from "okast-timeline";

import EPGMediaItemRenderer from "./EPGMediaItemRenderer";
import Tooltip from "../../tooltip/Tooltip";
import { MIN_ZOOM_IN_DURATION } from "../timeline/timeline";
import TimelineHeader from "../timeline/TimelineHeader";
import TimelineMarker from "../timeline/TimelineMarker";
import useTimeChange from "../timeline/useTimeChange";

import type { ReactCalendarItemRendererProps } from "okast-timeline";
import type { JSX } from "react";

import type { EPGTimelineItem } from "../timeline/timeline.types";

interface EPGTimelineProps {
  items: EPGTimelineItem[];
  minTime: number;
  maxTime: number;
}

const EPG_MAX_ZOOM = 1000 * 60 * 60 * 6; // 6 hours

export default function EPGTimeline({
  items,
  minTime,
  maxTime,
}: EPGTimelineProps): JSX.Element {
  const groups = [{ id: "1", title: "" }];

  const renderItem = ({
    itemContext,
    item,
    getItemProps,
  }: ReactCalendarItemRendererProps<EPGTimelineItem>): JSX.Element => (
    <EPGMediaItemRenderer
      getItemProps={getItemProps}
      item={item}
      itemContext={itemContext}
    />
  );

  const { handleTimeChange, visibleTimeStart, visibleTimeEnd } = useTimeChange({
    minTime,
    maxTime,
  });

  const getLineClassNamesForGroup = (): string[] => ["no-border"];

  return (
    <React.Fragment>
      <Timeline
        buffer={1}
        canChangeGroup={false}
        canResize={false}
        canWheelZoom={false}
        groups={groups}
        itemRenderer={renderItem}
        items={items}
        itemSizeRatio={0.9}
        lineClassNamesForGroup={getLineClassNamesForGroup}
        lineSize={170}
        maxZoomOutDuration={EPG_MAX_ZOOM}
        minZoomInDuration={MIN_ZOOM_IN_DURATION}
        onTimeChange={handleTimeChange}
        sidebarSize={0}
        visibleTimeEnd={visibleTimeEnd}
        visibleTimeStart={visibleTimeStart}
      >
        <TimelineHeader sidebarSize={0} />
        <TimelineMarker />
      </Timeline>
      <Tooltip id="timeline-tooltip" place="bottom" />
    </React.Fragment>
  );
}
